import type {
  CashflowBuilderConfig,
  CashflowRowMeta,
  CashflowRule,
  CashflowTemplateRow,
  FormulaDefinition,
  TemplateSection,
} from "../types";

const rows: CashflowTemplateRow[] = [
  {
    rowId: "operating_section",
    displayCode: "1.0",
    label: "ҮНДСЭН ҮЙЛ АЖИЛЛАГААНЫ МӨНГӨН ГҮЙЛГЭЭ",
    rowType: "section",
    order: 1,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_loans_interest_received",
    displayCode: "1.1",
    label: "Зээл, хүүгийн төлбөрт хүлээн авсан",
    rowType: "leaf",
    order: 2,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_trust_received",
    displayCode: "1.2",
    label: "Итгэлцлийн үйлчилгээнээс хүлээн авсан",
    rowType: "leaf",
    order: 3,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_emoney_received",
    displayCode: "1.3",
    label: "Цахим мөнгө гаргах, төлбөрийн үйлчилгээ үзүүлэхтэй холбогдуулан хүлээн авсан",
    rowType: "leaf",
    order: 4,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_factoring_received",
    displayCode: "1.4",
    label: "Факторингийн үйл ажиллагаанаас хүлээн авсан",
    rowType: "leaf",
    order: 5,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_other_received",
    displayCode: "1.5",
    label: "Бусад",
    rowType: "leaf",
    order: 6,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_cash_in_total",
    displayCode: "1.6",
    label: "Үндсэн үйл ажиллагааны мөнгөн орлого",
    rowType: "formula",
    order: 7,
    sectionId: "operating_section",
    formula: {
      kind: "sum",
      references: [
        "operating_loans_interest_received",
        "operating_trust_received",
        "operating_emoney_received",
        "operating_factoring_received",
        "operating_other_received",
      ],
      stage: 1,
      description: "SUM(1.1, 1.2, 1.3, 1.4, 1.5)",
    },
  },
  {
    rowId: "operating_loans_paid",
    displayCode: "1.7",
    label: "Олгосон зээл",
    rowType: "leaf",
    order: 8,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_trust_returned",
    displayCode: "1.8",
    label: "Буцаан олгосон итгэлцэл, үр шим",
    rowType: "leaf",
    order: 9,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_emoney_refunded",
    displayCode: "1.9",
    label: "Цахим мөнгө гаргах, төлбөрийн үйлчилгээ үзүүлэхтэй холбогдуулан буцаан шилжүүлсэн",
    rowType: "leaf",
    order: 10,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_factoring_transferred",
    displayCode: "1.1",
    label: "Факторингийн үйл ажиллагаагаар шилжүүлсэн",
    rowType: "leaf",
    order: 11,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_staff_paid",
    displayCode: "1.11",
    label: "Ажиллагсдад олгосон",
    rowType: "leaf",
    order: 12,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_tax_paid",
    displayCode: "1.12",
    label: "Татвар, нийгмийн даатгалын байгууллагад төлсөн",
    rowType: "leaf",
    order: 13,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_expenses_paid",
    displayCode: "1.13",
    label: "Ашиглалтын зардалд төлсөн",
    rowType: "leaf",
    order: 14,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_other_paid",
    displayCode: "1.14",
    label: "Бусад",
    rowType: "leaf",
    order: 15,
    sectionId: "operating_section",
  },
  {
    rowId: "operating_cash_out_total",
    displayCode: "1.15",
    label: "Үндсэн үйл ажиллагааны мөнгөн зарлага",
    rowType: "formula",
    order: 16,
    sectionId: "operating_section",
    formula: {
      kind: "sum",
      references: [
        "operating_loans_paid",
        "operating_trust_returned",
        "operating_emoney_refunded",
        "operating_factoring_transferred",
        "operating_staff_paid",
        "operating_tax_paid",
        "operating_expenses_paid",
        "operating_other_paid",
      ],
      stage: 1,
      description: "SUM(1.7 ... 1.14)",
    },
  },
  {
    rowId: "operating_net",
    displayCode: "1.16",
    label: "Үндсэн үйл ажиллагааны цэвэр мөнгөн гүйлгээний дүн",
    rowType: "formula",
    order: 17,
    sectionId: "operating_section",
    formula: {
      kind: "diff",
      references: ["operating_cash_in_total", "operating_cash_out_total"],
      stage: 2,
      description: "1.6 - 1.15",
    },
  },
  {
    rowId: "investment_section",
    displayCode: "2.0",
    label: "ХӨРӨНГӨ ОРУУЛАЛТЫН ҮЙЛ АЖИЛЛАГААНЫ МӨНГӨН ГҮЙЛГЭЭ",
    rowType: "section",
    order: 18,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_fixed_assets_sold",
    displayCode: "2.1",
    label: "Үндсэн хөрөнгө, биет бус хөрөнгө борлуулснаас хүлээн авсан",
    rowType: "leaf",
    order: 19,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_received",
    displayCode: "2.2",
    label: "Хөрөнгө оруулалтаас хүлээн авсан",
    rowType: "leaf",
    order: 20,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_other_long_assets_sold",
    displayCode: "2.3",
    label: "Бусад урт хугацаат хөрөнгө борлуулснаас хүлээн авсан",
    rowType: "leaf",
    order: 21,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_securities_sold",
    displayCode: "2.4",
    label: "Үнэт цаас борлуулснаас хүлээн авсан",
    rowType: "leaf",
    order: 22,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_dividends_received",
    displayCode: "2.5",
    label: "Хүлээн авсан ногдол ашиг",
    rowType: "leaf",
    order: 23,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_cash_in_total",
    displayCode: "2.6",
    label: "Хөрөнгө оруулалтын үйл ажиллагааны мөнгөн орлого",
    rowType: "formula",
    order: 24,
    sectionId: "investment_section",
    formula: {
      kind: "sum",
      references: [
        "investment_fixed_assets_sold",
        "investment_received",
        "investment_other_long_assets_sold",
        "investment_securities_sold",
        "investment_dividends_received",
      ],
      stage: 1,
      description: "SUM(2.1 ... 2.5)",
    },
  },
  {
    rowId: "investment_fixed_assets_acquired",
    displayCode: "2.7",
    label: "Үндсэн хөрөнгө, биет бус хөрөнгө олж эзэмшихэд төлсөн",
    rowType: "leaf",
    order: 25,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_acquired",
    displayCode: "2.8",
    label: "Хөрөнгө оруулалт олж эзэмшихэд төлсөн",
    rowType: "leaf",
    order: 26,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_other_long_assets_acquired",
    displayCode: "2.9",
    label: "Бусад урт хугацаат хөрөнгө олж эзэмшихэд төлсөн",
    rowType: "leaf",
    order: 27,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_securities_acquired",
    displayCode: "2.1",
    label: "Үнэт цаас олж эзэмшихэд төлсөн",
    rowType: "leaf",
    order: 28,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_other_paid",
    displayCode: "2.11",
    label: "Бусад",
    rowType: "leaf",
    order: 29,
    sectionId: "investment_section",
  },
  {
    rowId: "investment_cash_out_total",
    displayCode: "2.12",
    label: "Хөрөнгө оруулалтын үйл ажиллагааны мөнгөн зарлага",
    rowType: "formula",
    order: 30,
    sectionId: "investment_section",
    formula: {
      kind: "sum",
      references: [
        "investment_fixed_assets_acquired",
        "investment_acquired",
        "investment_other_long_assets_acquired",
        "investment_securities_acquired",
        "investment_other_paid",
      ],
      stage: 1,
      description: "SUM(2.7 ... 2.11)",
    },
  },
  {
    rowId: "investment_net",
    displayCode: "2.13",
    label: "Хөрөнгө оруулалтын үйл ажиллагааны цэвэр мөнгөн гүйлгээний дүн",
    rowType: "formula",
    order: 31,
    sectionId: "investment_section",
    formula: {
      kind: "diff",
      references: ["investment_cash_in_total", "investment_cash_out_total"],
      stage: 2,
      description: "2.6 - 2.12",
    },
  },
  {
    rowId: "financing_section",
    displayCode: "3.0",
    label: "САНХҮҮГИЙН ҮЙЛ АЖИЛЛАГААНЫ МӨНГӨН ГҮЙЛГЭЭ",
    rowType: "section",
    order: 32,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_loans_received",
    displayCode: "3.1",
    label: "Банк, санхүүгийн байгууллага, төсөл, хөтөлбөрийн зээлээс хүлээн авсан",
    rowType: "leaf",
    order: 33,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_secondary_liabilities_received",
    displayCode: "3.2",
    label: "Хоёрдогч өглөгөөс хүлээн авсан",
    rowType: "leaf",
    order: 34,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_shares_received",
    displayCode: "3.3",
    label: "Хувьцаа болон өмчийн бусад үнэт цаас гаргаснаас хүлээн авсан",
    rowType: "leaf",
    order: 35,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_other_received",
    displayCode: "3.4",
    label: "Бусад",
    rowType: "leaf",
    order: 36,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_cash_in_total",
    displayCode: "3.5",
    label: "Санхүүгийн үйл ажиллагааны мөнгөн орлого",
    rowType: "formula",
    order: 37,
    sectionId: "financing_section",
    formula: {
      kind: "sum",
      references: [
        "financing_loans_received",
        "financing_secondary_liabilities_received",
        "financing_shares_received",
        "financing_other_received",
      ],
      stage: 1,
      description: "SUM(3.1 ... 3.4)",
    },
  },
  {
    rowId: "financing_loans_paid",
    displayCode: "3.6",
    label: "Банк, санхүүгийн байгууллага, төсөл, хөтөлбөрийн зээлд төлсөн",
    rowType: "leaf",
    order: 38,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_secondary_liabilities_paid",
    displayCode: "3.7",
    label: "Хоёрдогч өглөгт төлсөн",
    rowType: "leaf",
    order: 39,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_dividends_paid",
    displayCode: "3.8",
    label: "Төлсөн ногдол ашиг",
    rowType: "leaf",
    order: 40,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_other_paid",
    displayCode: "3.9",
    label: "Бусад",
    rowType: "leaf",
    order: 41,
    sectionId: "financing_section",
  },
  {
    rowId: "financing_cash_out_total",
    displayCode: "3.1",
    label: "Санхүүгийн үйл ажиллагааны мөнгөн зарлага",
    rowType: "formula",
    order: 42,
    sectionId: "financing_section",
    formula: {
      kind: "sum",
      references: [
        "financing_loans_paid",
        "financing_secondary_liabilities_paid",
        "financing_dividends_paid",
        "financing_other_paid",
      ],
      stage: 1,
      description: "SUM(3.6 ... 3.9)",
    },
  },
  {
    rowId: "financing_net",
    displayCode: "3.11",
    label: "Санхүүгийн үйл ажиллагааны цэвэр мөнгөн гүйлгээний дүн",
    rowType: "formula",
    order: 43,
    sectionId: "financing_section",
    formula: {
      kind: "diff",
      references: ["financing_cash_in_total", "financing_cash_out_total"],
      stage: 2,
      description: "3.5 - 3.10",
    },
  },
  {
    rowId: "fx_difference",
    displayCode: "4.0",
    label: "Валютын ханшийн зөрүү",
    rowType: "leaf",
    order: 44,
    sectionId: "summary_section",
  },
  {
    rowId: "all_net_cashflows",
    displayCode: "5.0",
    label: "Бүх цэвэр мөнгөн гүйлгээ",
    rowType: "formula",
    order: 45,
    sectionId: "summary_section",
    formula: {
      kind: "sum",
      references: ["operating_net", "investment_net", "financing_net", "fx_difference"],
      stage: 3,
      description: "1.16 + 2.13 + 3.11 + 4.0",
    },
  },
  {
    rowId: "opening_cash_equivalents",
    displayCode: "6.0",
    label: "Мөнгө ба түүнтэй адилтгах хөрөнгийн эхний үлдэгдэл",
    rowType: "leaf",
    order: 46,
    sectionId: "summary_section",
  },
  {
    rowId: "closing_cash_equivalents",
    displayCode: "7.0",
    label: "Мөнгө ба түүнтэй адилтгах хөрөнгийн эцсийн үлдэгдэл",
    rowType: "leaf",
    order: 47,
    sectionId: "summary_section",
  },
];

for (const row of rows) {
  row.internalName = row.rowId;
}

export const cashflowTemplateRows = rows;

export const templateSections: TemplateSection[] = [
  {
    rowId: "operating_section",
    displayCode: "1.0",
    label: "Үндсэн үйл ажиллагаа",
    startOrder: 1,
  },
  {
    rowId: "investment_section",
    displayCode: "2.0",
    label: "Хөрөнгө оруулалт",
    startOrder: 18,
  },
  {
    rowId: "financing_section",
    displayCode: "3.0",
    label: "Санхүүжилт",
    startOrder: 32,
  },
  {
    rowId: "summary_section",
    displayCode: "4.0+",
    label: "Дүгнэлт",
    startOrder: 44,
  },
];

export const editableRows = cashflowTemplateRows.filter((row) => row.rowType === "leaf");
export const formulaRows = cashflowTemplateRows.filter((row) => row.rowType === "formula");

export const rowMap = new Map(cashflowTemplateRows.map((row) => [row.rowId, row]));

export const defaultRowMeta: Record<string, CashflowRowMeta> = Object.fromEntries(
  cashflowTemplateRows.map((row) => [
    row.rowId,
    {
      displayCode: row.displayCode,
      label: row.label,
      internalName: row.internalName ?? row.rowId,
    },
  ]),
);

export function createRule(rowId: string): CashflowRule {
  return {
    id: crypto.randomUUID(),
    rowId,
    dt_match_type: "gl_code",
    kt_match_type: "gl_code",
    debitValue: "",
    creditValue: "",
    amountSide: "CR",
    coefficient: 1,
  };
}

function createInitialRows(): Record<string, CashflowRule[]> {
  const rowsRecord: Record<string, CashflowRule[]> = {};

  for (const row of editableRows) {
    rowsRecord[row.rowId] = [];
  }

  rowsRecord.operating_loans_interest_received = [
    {
      id: "seed-gl-1",
      rowId: "operating_loans_interest_received",
      dt_match_type: "gl_code",
      kt_match_type: "gl_code",
      debitValue: "11211000",
      creditValue: "42310000",
      amountSide: "CR",
      coefficient: 1,
    },
    {
      id: "seed-gl-2",
      rowId: "operating_loans_interest_received",
      dt_match_type: "gl_code",
      kt_match_type: "gl_code",
      debitValue: "11211000",
      creditValue: "12731000",
      amountSide: "CR",
      coefficient: 1,
    },
    {
      id: "seed-gl-3",
      rowId: "operating_loans_interest_received",
      dt_match_type: "gl_code",
      kt_match_type: "gl_code",
      debitValue: "11211100",
      creditValue: "42400000",
      amountSide: "DR",
      coefficient: 1,
    },
  ];

  return rowsRecord;
}

export const defaultConfig: CashflowBuilderConfig = {
  version: 1,
  templateId: "cashflow-v1",
  startDate: "2026-03-01",
  endDate: "2026-04-01",
  removedTemplateRowIds: [],
  rowMeta: defaultRowMeta,
  customRows: [],
  formulas: Object.fromEntries(
    formulaRows.map((row) => [
      row.rowId,
      {
        kind: row.formula!.kind,
        references: [...row.formula!.references],
        stage: row.formula!.stage,
        description: row.formula!.description,
      } satisfies FormulaDefinition,
    ]),
  ),
  rows: createInitialRows(),
};

export function getRowsForConfig(config: CashflowBuilderConfig): CashflowTemplateRow[] {
  const removedSet = new Set(config.removedTemplateRowIds ?? []);

  return [...cashflowTemplateRows, ...config.customRows]
    .filter((row) => !(rowMap.has(row.rowId) && removedSet.has(row.rowId)))
    .sort((left, right) => left.order - right.order);
}
